import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../../hooks";
import { Spinner } from "flowbite-react";

const CampaignList: React.FC = () => {
  const navigate = useNavigate();
  const { selectedIntegration } = useAuth();

  useEffect(() => {
    if (selectedIntegration) {
      const integratedPlatforms = new Set([
        ...(selectedIntegration.inwardPlatforms || []),
        ...(selectedIntegration.outwardPlatforms || []),
      ]);

      if (integratedPlatforms.has("google_ads")) {
        navigate("/campaigns/google-ads", { replace: true });
      } else if (integratedPlatforms.has("meta_ads") || integratedPlatforms.has("facebook")) {
        navigate("/campaigns/meta-ads", { replace: true });
      } else if (integratedPlatforms.has("apple_search_ads") || integratedPlatforms.has("apple_ads")) {
        navigate("/campaigns/apple-search-ads", { replace: true });
      } else {
        // If no ad platform is integrated, redirect to integrations page
        navigate("/integrations", { replace: true });
      }
    }
  }, [selectedIntegration, navigate]);

  return (
    <div className="flex items-center justify-center h-[calc(100vh-200px)]">
      <Spinner size="xl" />
    </div>
  );
};

export default CampaignList;
